import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        catalog: 'Catalog', // Kept original, can be "Collections"
        products: 'Our Products', // Updated from PDF context
        reviews: 'Reviews', // Kept original
        about: 'About Us', // Updated from PDF context
        contact: 'Contact Us' // Updated from PDF context
      },
      hero: {
        title: 'Hussein Abd Elfattah', // From PDF
        subtitle: 'Decorative Furniture Since 1980', // From PDF
        description: 'Leading manufacturing company in producing high-end furniture gilded with real bronze. We combine creativity, craftsmanship and technology.', // Adapted from PDF 7
        cta: 'Discover Our Collections', // Generic CTA
        premiumCollection: 'Decorative Furniture' // Adapted from PDF
      },
      // --- Sections based on the PDF content ---
      companyProfile: {
        historyTitle: 'History and Background', //
        historyP1: 'Hussein Abdelfattah decorative furniture is a leading manufacturing company in producing high-end furniture gilded with real bronze. We initially started with a small workshop in "El ras le soda" in 1980. In 1985 we established our 1st factory in "Seyouf" Alexandria. Eventually, we added "Mirgim" factory.',
        historyP2: 'We exemplify creativity in every sense of the word. We create ambience that is impressive and we set an inspiration. We proudly design, develop and manufacture our entire range of products in Egypt.',
        historyP3: 'We combine creativity, craftsmanship and technology to create furniture suited for discerning customers, locally and internationally. Through years of hardwork and company-customer relationship we have gained considerable experience in dealing with customers and big retail companies.',
        historyP4: 'We only use very fine raw materials to ensure the best quality same like antique with new high quality different kinds of wood.',
        chairmanTitle: 'A Word from Our Chairman', //
        chairmanName: 'EL HUSSEIN ABDELFATTАН', //
        chairmanSpeechP1: 'Having a legacy of over 40 years of industry, believing in Egypt and the Egyptian industry. Relying on continuous development in our products, racing up for technology, having the passion for furniture, willing to work hard to produce a "Made in Egypt" product to invade and conquer the global market.',
        chairmanSpeechP2: 'Compromising is unacceptable to our hard core standards. Developing our team to be one positive family is what really "Hussein Abdelfattah furniture" is about.',
        chairmanSpeechP3: 'Our customers are our partners in success, which is why it is always a long term relationship that is built on trust, respect and care. At "Hussein Abdelfattah furniture" we do this, by creating products that meet expectations and aspirations of customers who share the same values as we do.',
        chairmanSignature: 'Sincerely, ElHussein Abdelfattah "chairman"', //
        ideologyTitle: 'Our Ideology', //
        ideologyP1: 'We create timeless, luxurious, stylish yet comfortable pieces to meet regional and global market demands. Each item is produced to the highest standards using both the latest technology along with the craftsmanship.',
        ideologyP2: 'Our products are created to elevate the corner it is made for, we create the ambiance you will always look for and feel comfortable in.',
        teamTitle: 'Our Team', //
        teamP1: 'Our people are our assets, our reputation is only as good as the people that work for us, and that is why "Hussein Abdelfattah " has belt a team of nearly 150 staff all dedicated to ensure the very best quality in furniture design and manufacturing.',
        teamP2: 'Our team comes from a diverse variety of backgrounds and experiences, these keep the creativity flow is unstoppable. Our company is equal-opportunities employe. Our management is on hand to develop and encourage all team members, as well as provide a sustainable working environment.',
        teamP3: 'All "Hussein Abdelfattah furniture employees and management operate with a customer-centric approach.',
        showroomsTitle: 'Head offices and showrooms', //
        showroomsP1: 'ElHussein Abdelfattah furniture head quarters is located in factory perimeter in "Elsoyouf" Alexandria where we arrange meetings, calls and business transactions.',
        showroomsP2: 'We also have two showrooms, in Cairo "Nasr city" and in Alexandria "Smouha" where we can meet our customers and show them a wide variety of our products.',
        productsTitle: 'Our Products', // (Referring to the section title on page 9)
        eventsTitle: 'Communication and events', //
        eventsP1: 'Our company is always concerned to build communication channels between our company and our customers worldwide, so we are always keen to join different exhibitions and to make a remarkable presentation.',
        furnex2009: '2009 Furnex international exhibition',
        furnex2010: '2010 Furnex International exhibition',
        furnex2013: '2013 Furnex International exhibition',
        houseAlex2014: '2014 House of furnite - Alexandria',
        furnex2016: '2016 Furnex International exhibition',
        houseAlex2020: '2020 House of furnite - Alexandria',
        summaryTitle: 'Company summary', //
        summaryP1: 'We concentrate on the continuous improvement of the product according to customers and market needs. So we specifically follow the product concept.',
        summaryP2: 'We export globally to different regions worldwide such as USA, Canada, Australia, France, Spain, Syria, emirates and Saudi Arabia.',
        contactTitle: 'Contact Us', // (Section title)
        alexOfficeAddress: 'Alexandria head office: 38 Ahmed Riad Turk, El Soyouf, Alexandria, Egypt',
        alexMobile1: 'Mobile no. +2 01227316680',
        alexMobile2: 'Mobile no(2) +2 01005379993',
        alexLandline: 'Landline: +2 03 5025171',
        beauBoisShowroomAddress: 'Beau bois showroom: 38 Ahmed Riad Turk, El Soyouf, Alexandria, Egypt',
        beauBoisMobile: 'Mobile no. +201223922117',
        beauBoisLandline: 'Landline: +2 03 4230826',
        cairoShowroomAddress: 'Cairo showroom: Al Nozha st. Building no. 14, Saudi company buildings, store no.3, Nasr city, Cairo, Egypt'
      },
      // --- Kept original sections below, as requested ---
      catalog: {
        title: 'Our Furniture Collections',
        subtitle: 'Browse through our carefully curated categories',
        livingRoom: 'Living Room',
        bedroom: 'Bedroom',
        diningRoom: 'Dining Room',
        office: 'Office',
        outdoor: 'Outdoor',
        products: 'Products', // This key also exists in companyProfile, be mindful of which one you use
        nextPage: 'Next',
        prevPage: 'Previous'
      },
      product: {
        description: 'Description',
        specifications: 'Specifications',
        backToCatalog: 'Back to Catalog',
        viewDetails: 'View Details',
        notFound: 'Product not found',
        backToProducts: 'Back to Products',
        contactForPricing: 'Contact for Pricing',
        addToWishlist: 'Add to Wishlist'
      },
      filter: {
        all: 'All Categories',
        allPrices: 'All Prices',
        under1000: 'Under $1,000',
        range1000: '$1,000 - $2,000',
        range2000: '$2,000 - $3,000',
        over3000: 'Over $3,000',
        search: 'Search products...',
        showing: 'Showing',
        products: 'products', // This key also exists in companyProfile and catalog, be mindful
        noProducts: 'No products found',
        tryDifferent: 'Try adjusting your filters'
      },
      products: { // This is the original 'products' section (distinct from companyProfile.productsTitle)
        subtitle: 'Discover our complete furniture collection'
      },
      contact: { // This is the original 'contact' section for a general form
        title: 'Get in Touch', // General title for a contact form perhaps
        subtitle: 'We\'d love to hear from you. Send us a message and we\'ll respond as soon as possible.',
        interestedTitle: 'Interested in this product?',
        whatsapp: 'WhatsApp Us',
        call: 'Call Us',
        note: 'Note',
        noteText: 'Contact us for pricing, availability, and delivery options.',
        followUs: 'Follow Us',
        name: 'Your Name',
        email: 'Your Email',
        message: 'Your Message',
        send: 'Send Message',
        getInTouch: 'Get in Touch',
        sendMessage: 'Send us a Message',
        phone: 'Phone', // General phone, PDF specific are in companyProfile
        address: 'Address', // General address, PDF specific are in companyProfile
        success: 'Success',
        error: 'Error',
        successMessage: 'Your message has been sent successfully!',
        errorMessage: 'Please fill in all fields',
        interactiveMap: 'Interactive Map',
        visitShowroom: 'Visit our showroom',
        "swal": {
          "successTitle": "Message Sent!",
          "successText": "We will get back to you as soon as possible!",
          "errorTitle": "Error!",
          "networkErrorText": "An error occurred while sending the message. Please try again."
        }
      },
      whatsapp: {
        hello: 'Hello! I am interested in',
        interested: 'Could you please provide more information?'
      },
      "reviews": {
        "title": "What Our Customers Say",
        "subtitle": "Read the opinions and experiences of our valued customers.",
        "customerReviews": "Customer Reviews",
        "writeReview": "Write Your Review",
        "yourName": "Your Name",
        "rating": "Your Rating",
        "yourReview": "Your Review",
        "submit": "Submit Review",
        "validation": {
          "ratingRequired": "Please select your rating"
        },
        "noReviewsFound": 'No reviews found yet.',
        "beTheFirst": 'Be the first to share your opinion!',
        "swal": {
          "successTitle": "Review Submitted!",
          "successText": "Thank you for your feedback!",
          "errorTitle": "Error!",
          "networkErrorText": "An error occurred while submitting. Please try again."
        }
      },
      about: { // This is the original 'about' section
        title: 'About Elegance Furniture', // Original title
        subtitle: 'Crafting beautiful spaces since 1995', // Original subtitle
        description: 'For over 25 years, Elegance Furniture has been at the forefront of creating exceptional furniture pieces that transform houses into homes. Our journey began with a simple vision: to bring together timeless design, superior craftsmanship, and uncompromising quality.',
        mission: 'Our mission is to provide our customers with furniture that not only meets their functional needs but also reflects their personal style and enhances their living spaces. We believe that great furniture should be an investment in comfort, beauty, and lasting value.',
        values: 'We are committed to sustainability, ethical sourcing, and supporting local artisans. Every piece in our collection is carefully selected or crafted with attention to detail, ensuring that it will serve you beautifully for years to come.',
        location: 'Visit Our Showroom',
        address: '123 Design Avenue, Cairo, Egypt', // Original address
        happyCustomers: 'Happy Customers',
        yearsExperience: 'Years Experience',
        customerSupport: 'Customer Support',
        ourShowroom: 'Our Showroom'
      },
      footer: {
        allRightsReserved: 'All rights reserved.',
        craftingSince: 'Decorative Furniture Since 1980' // Updated from PDF
      },
      "faq": {
        "title": "Frequently Asked Questions",
        "subtitle": "Find answers to the most common questions about our products and services.",
        "q1": {
          "question": "What materials do you use in your products?",
          "answer": "We pride ourselves on using high-quality, sustainable materials. Each product page has a detailed list of materials used. For our main line, we primarily use solid oak, walnut, and premium fabrics."
        },
        "q2": {
          "question": "Do you offer international shipping?",
          "answer": "Yes, we ship to most countries worldwide. Shipping costs and delivery times vary depending on the destination. You can get an estimate during the checkout process before confirming your order."
        },
        "q3": {
          "question": "What is your return policy?",
          "answer": "We offer a 30-day return policy for unused items in their original packaging. Please visit our 'Returns & Exchanges' page for detailed instructions on how to initiate a return."
        },
      }
    }
  },
  ar: {
    translation: {
      nav: {
        home: 'الرئيسية',
        catalog: 'كتالوج',
        products: 'منتجاتنا',
        reviews: 'التقييمات',
        about: 'من نحن',
        contact: 'اتصل بنا'
      },
      hero: {
        title: 'حسين عبد الفتاح', // From PDF
        subtitle: 'للأثاث الفاخر منذ 1980', // From PDF
        description: 'شركة رائدة في إنتاج الأثاث الفاخر المذهب بالبرونز الخالص. نجمع بين الإبداع، الحرفية والتكنولوجيا.', // Adapted from PDF 7
        cta: 'اكتشف مجموعاتنا',
        premiumCollection: 'أثاث فاخر' // Adapted from PDF
      },
      companyProfile: {
        historyTitle: 'التاريخ والخلفية', //
        historyP1: 'شركة حسين عبد الفتاح للأثاث الفاخر هي شركة رائدة في إنتاج الأثاث عالي الجودة المذهب بالبرونز الحقيقي. بدأنا بورشة صغيرة في "الراس السودا" عام 1980. وفي عام 1985، أنشأنا أول مصنع لنا في "السيوف" بالإسكندرية. ثم أضفنا مصنع "مرغم".',
        historyP2: 'نحن نجسد الإبداع بكل معنى الكلمة. نخلق أجواءً مبهرة ونضع الإلهام. نصمم ونطور ونصنع بفخر مجموعتنا الكاملة من المنتجات في مصر.',
        historyP3: 'نحن نجمع بين الإبداع والحرفية والتكنولوجيا لابتكار أثاث يناسب العملاء المميزين، محليًا ودوليًا. خلال سنوات من العمل الجاد والعلاقة بين الشركة والعملاء، اكتسبنا خبرة كبيرة في التعامل مع العملاء وكبرى شركات البيع بالتجزئة.',
        historyP4: 'نستخدم فقط أجود الخامات لضمان أفضل جودة تماثل التحف العتيقة مع أنواع جديدة عالية الجودة من الأخشاب المختلفة.',
        chairmanTitle: 'كلمة رئيس مجلس الإدارة', //
        chairmanName: 'الحسين عبد الفتاح', //
        chairmanSpeechP1: 'بإرث يمتد لأكثر من 40 عامًا في الصناعة، وإيمانًا بمصر والصناعة المصرية. بالاعتماد على التطوير المستمر في منتجاتنا، والسعي نحو التكنولوجيا، والشغف بالأثاث، والاستعداد للعمل الجاد لإنتاج منتج "صنع في مصر" لغزو السوق العالمي والسيطرة عليه.',
        chairmanSpeechP2: 'التنازلات غير مقبولة لمعاييرنا الأساسية الصارمة. تطوير فريقنا ليكون عائلة واحدة إيجابية هو ما يمثل حقًا "أثاث حسين عبد الفتاح".',
        chairmanSpeechP3: 'عملاؤنا هم شركاؤنا في النجاح، ولهذا السبب هي دائمًا علاقة طويلة الأمد مبنية على الثقة والاحترام والرعاية. في "أثاث حسين عبد الفتاح"، نقوم بذلك من خلال إنشاء منتجات تلبي توقعات وتطلعات العملاء الذين يشاركوننا نفس القيم.',
        chairmanSignature: 'مع خالص التقدير، الحسين عبد الفتاح "رئيس مجلس الإدارة"', //
        ideologyTitle: 'فلسفتنا', //
        ideologyP1: 'نحن نبتكر قطعًا خالدة، فاخرة، أنيقة ومريحة في نفس الوقت لتلبية متطلبات السوق الإقليمية والعالمية. يتم إنتاج كل قطعة وفقًا لأعلى المعايير باستخدام أحدث التقنيات جنبًا إلى جنب مع الحرفية اليدوية.',
        ideologyP2: 'منتجاتنا مصممة لترتقي بالركن الذي صنعت من أجله، نحن نخلق الأجواء التي ستبحث عنها دائمًا وتشعر فيها بالراحة.',
        teamTitle: 'فريقنا', //
        teamP1: 'موظفونا هم أصولنا، سمعتنا لا تتعدى جودة الأشخاص الذين يعملون لدينا، ولهذا السبب قامت "حسين عبد الفتاح" ببناء فريق يضم ما يقرب من 150 موظفًا، جميعهم مكرسون لضمان أفضل جودة في تصميم وتصنيع الأثاث.',
        teamP2: 'يأتي فريقنا من خلفيات وخبرات متنوعة، وهذا ما يجعل تدفق الإبداع لا يتوقف. شركتنا هي جهة توظيف تكافؤ الفرص. إدارتنا جاهزة لتطوير وتشجيع جميع أعضاء الفريق، بالإضافة إلى توفير بيئة عمل مستدامة.',
        teamP3: 'يعمل جميع موظفي وإدارة شركة "حسين عبد الفتاح للأثاث" بمنهجية تتمحور حول العميل.',
        showroomsTitle: 'المكاتب الرئيسية والمعارض', //
        showroomsP1: 'يقع المقر الرئيسي لشركة حسين عبد الفتاح للأثاث في محيط المصنع في "السيوف" بالإسكندرية حيث ننظم الاجتماعات والمكالمات والمعاملات التجارية.',
        showroomsP2: 'لدينا أيضًا معرضان، في القاهرة "مدينة نصر" وفي الإسكندرية "سموحة" حيث يمكننا مقابلة عملائنا وعرض مجموعة واسعة من منتجاتنا لهم.',
        productsTitle: 'منتجاتنا', //
        eventsTitle: 'التواصل والفعاليات', //
        eventsP1: 'تهتم شركتنا دائمًا ببناء قنوات اتصال بين شركتنا وعملائنا في جميع أنحاء العالم، لذا نحرص دائمًا على الانضمام إلى المعارض المختلفة وتقديم عرض تقديمي لافت.',
        furnex2009: 'معرض فرنتشر الدولي 2009',
        furnex2010: 'معرض فرنتشر الدولي 2010',
        furnex2013: 'معرض فرنتشر الدولي 2013',
        houseAlex2014: 'بيت الأثاث - الإسكندرية 2014',
        furnex2016: 'معرض فرنتشر الدولي 2016',
        houseAlex2020: 'بيت الأثاث - الإسكندرية 2020',
        summaryTitle: 'ملخص الشركة', //
        summaryP1: 'نركز على التحسين المستمر للمنتج وفقًا لاحتياجات العملاء والسوق. لذا، نتبع مفهوم المنتج على وجه التحديد.',
        summaryP2: 'نصدر عالميًا إلى مناطق مختلفة حول العالم مثل الولايات المتحدة الأمريكية، كندا، أستراليا، فرنسا، إسبانيا، سوريا، الإمارات العربية المتحدة، والمملكة العربية السعودية.',
        contactTitle: 'اتصل بنا', //
        alexOfficeAddress: 'المقر الرئيسي بالإسكندرية: 38 شارع أحمد رياض ترك، السيوف، الإسكندرية، مصر',
        alexMobile1: 'محمول: 01227316680 2+',
        alexMobile2: 'محمول (2): 01005379993 2+',
        alexLandline: 'هاتف أرضي: 5025171 03 2+',
        beauBoisShowroomAddress: 'معرض بو بوا: 34 شارع توت عنخ آمون، سموحة، الإسكندرية، مصر',
        beauBoisMobile: 'محمول: 201223922117+',
        beauBoisLandline: 'هاتف أرضي: 4230826 03 2+',
        cairoShowroomAddress: 'معرض القاهرة: شارع النزهة، عمارة رقم 14، عمارات الشركة السعودية، محل رقم 3، مدينة نصر، القاهرة، مصر'
      },
      catalog: { // Original content
        title: 'مجموعات الأثاث',
        subtitle: 'تصفح فئاتنا المختارة بعناية',
        livingRoom: 'غرفة المعيشة',
        bedroom: 'غرفة النوم',
        diningRoom: 'غرفة الطعام',
        office: 'المكتب',
        outdoor: 'أثاث خارجي',
        products: 'المنتجات',
        nextPage: 'التالي',
        prevPage: 'السابق'
      },
      product: { // Original content
        description: 'الوصف',
        specifications: 'المواصفات',
        backToCatalog: 'العودة للكتالوج',
        viewDetails: 'عرض التفاصيل',
        notFound: 'المنتج غير موجود',
        backToProducts: 'العودة للمنتجات',
        contactForPricing: 'تواصل للاستعلام عن السعر',
        addToWishlist: 'أضف لقائمة الأمنيات'
      },
      filter: { // Original content
        all: 'جميع الفئات',
        allPrices: 'جميع الأسعار',
        under1000: 'أقل من 1000 دولار',
        range1000: '1000 - 2000 دولار',
        range2000: '2000 - 3000 دولار',
        over3000: 'أكثر من 3000 دولار',
        search: 'البحث في المنتجات...',
        showing: 'عرض',
        products: 'منتجات',
        noProducts: 'لم يتم العثور على منتجات',
        tryDifferent: 'جرب تعديل الفلاتر'
      },
      products: { // Original content
        subtitle: 'اكتشف مجموعة الأثاث الكاملة'
      },
      contact: { // Original content for a general form
        title: 'تواصل معنا',
        subtitle: 'نحن نحب أن نسمع منك. أرسل لنا رسالة وسنرد في أقرب وقت ممكن.',
        interestedTitle: 'مهتم بهذا المنتج؟',
        whatsapp: 'واتساب',
        call: 'اتصل بنا',
        note: 'ملاحظة',
        noteText: 'تواصل معنا للحصول على الأسعار والتوفر وخيارات التوصيل.',
        followUs: 'تابعنا',
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        message: 'الرسالة',
        send: 'إرسال الرسالة',
        getInTouch: 'تواصل معنا',
        sendMessage: 'أرسل لنا رسالة',
        phone: 'الهاتف',
        address: 'العنوان',
        success: 'نجح',
        error: 'خطأ',
        successMessage: 'تم إرسال رسالتك بنجاح!',
        errorMessage: 'يرجى ملء جميع الحقول',
        interactiveMap: 'خريطة تفاعلية',
        visitShowroom: 'زر معرضنا',
        "swal": {
          "successTitle": "تم إرسال الرسالة!",
          "successText": "سوف يتم الرد عليك في أقرب وقت!",
          "errorTitle": "خطأ!",
          "networkErrorText": "حدث خطأ أثناء إرسال الرسالة. حاول مرة أخرى."
        }
      },
      whatsapp: { // Original content
        hello: 'مرحبا! أنا مهتم بـ',
        interested: 'هل يمكنك تزويدي بمزيد من المعلومات؟'
      },
      "reviews": {
        "title": "ماذا يقول عملاؤنا",
        "subtitle": "اقرأ آراء وتجارب عملائنا الكرام.",
        "customerReviews": "تقييمات العملاء",
        "writeReview": "اكتب تقييمك",
        "yourName": "اسمك",
        "rating": "تقييمك",
        "yourReview": "مراجعتك",
        "submit": "إرسال التقييم",
        "validation": {
          "ratingRequired": "الرجاء اختيار تقييمك"
        },
        "noReviewsFound": 'لا توجد تقييمات حتى الآن.',
        "beTheFirst": 'كن أول من يشاركنا رأيك!',
        "swal": {
          "successTitle": "تم إرسال التقييم!",
          "successText": "شكراً لتقييمك لنا!",
          "errorTitle": "خطأ!",
          "networkErrorText": "حدث خطأ أثناء إرسال التقييم. حاول مرة أخرى."
        }
      },
      about: { // Original content
        title: 'حول أثاث الأناقة',
        subtitle: 'نصنع المساحات الجميلة منذ 1995',
        description: 'لأكثر من 25 عاماً، كانت شركة أثاث الأناقة في المقدمة في إنشاء قطع أثاث استثنائية تحول البيوت إلى منازل. بدأت رحلتنا برؤية بسيطة: الجمع بين التصميم الخالد والحرفية المتفوقة والجودة التي لا تقبل المساومة.',
        mission: 'مهمتنا هي تزويد عملائنا بأثاث لا يلبي احتياجاتهم الوظيفية فحسب، بل يعكس أيضاً أسلوبهم الشخصي ويعزز مساحات معيشتهم. نحن نؤمن أن الأثاث الرائع يجب أن يكون استثماراً في الراحة والجمال والقيمة الدائمة.',
        values: 'نحن ملتزمون بالاستدامة والمصادر الأخلاقية ودعم الحرفيين المحليين. كل قطعة في مجموعتنا مختارة أو مصنوعة بعناية مع الاهتمام بالتفاصيل، مما يضمن أنها ستخدمك بجمال لسنوات قادمة.',
        location: 'زر معرضنا',
        address: '123 شارع التصميم، القاهرة، مصر',
        happyCustomers: 'عميل راضي',
        yearsExperience: 'سنة خبرة',
        customerSupport: 'دعم العملاء',
        ourShowroom: 'معرضنا'
      },
      footer: {
        allRightsReserved: 'جميع الحقوق محفوظة.',
        craftingSince: 'للأثاث الفاخر منذ 1980' // Updated from PDF
      },
      "faq": {
        "title": "الأسئلة المتكررة",
        "subtitle": "ابحث عن إجابات للأسئلة الأكثر شيوعًا حول منتجاتنا وخدماتنا.",
      }
    }
  },
  fr: {
    translation: {
      nav: {
        home: 'Accueil',
        catalog: 'Catalogue',
        products: 'Nos Produits',
        reviews: 'Avis',
        about: 'À Propos de Nous',
        contact: 'Contactez-Nous'
      },
      hero: {
        title: 'Hussein Abd Elfattah', // From PDF
        subtitle: 'Meubles Décoratifs Depuis 1980', // From PDF
        description: 'Société leader dans la fabrication de meubles haut de gamme dorés au bronze véritable. Nous allions créativité, savoir-faire artisanal et technologie.', // Adapted from PDF 7
        cta: 'Découvrez Nos Collections',
        premiumCollection: 'Meubles Décoratifs' // Adapted from PDF
      },
      companyProfile: {
        historyTitle: 'Histoire et Contexte', //
        historyP1: 'Hussein Abdelfattah decorative furniture est une entreprise de fabrication de premier plan dans la production de meubles haut de gamme dorés au bronze véritable. Nous avons initialement commencé avec un petit atelier à "El ras le soda" en 1980. En 1985, nous avons établi notre première usine à "Seyouf" à Alexandrie. Finalement, nous avons ajouté l\'usine "Mirgim".',
        historyP2: 'Nous incarnons la créativité dans tous les sens du terme. Nous créons une ambiance impressionnante et nous sommes une source d\'inspiration. Nous concevons, développons et fabriquons fièrement toute notre gamme de produits en Égypte.',
        historyP3: 'Nous combinons créativité, savoir-faire et technologie pour créer des meubles adaptés à une clientèle exigeante, locale et internationale. Grâce à des années de travail acharné et de relations entre l\'entreprise et ses clients, nous avons acquis une expérience considérable dans nos rapports avec les clients et les grandes entreprises de vente au détail.',
        historyP4: 'Nous n\'utilisons que des matières premières de très haute qualité pour garantir la meilleure qualité, comparable aux antiquités, avec de nouveaux types de bois de haute qualité.',
        chairmanTitle: 'Un Mot de Notre Président', //
        chairmanName: 'EL HUSSEIN ABDELFATTАН', //
        chairmanSpeechP1: 'Fort d\'un héritage de plus de 40 ans dans l\'industrie, croyant en l\'Égypte et en l\'industrie égyptienne. S\'appuyant sur le développement continu de nos produits, en course vers la technologie, ayant la passion du meuble, désireux de travailler dur pour produire un produit "Made in Egypt" pour envahir et conquérir le marché mondial.',
        chairmanSpeechP2: 'Le compromis est inacceptable pour nos normes fondamentales rigoureuses. Développer notre équipe pour en faire une famille positive et unie, voilà ce qu\'est réellement "Hussein Abdelfattah furniture".',
        chairmanSpeechP3: 'Nos clients sont nos partenaires de succès, c\'est pourquoi il s\'agit toujours d\'une relation à long terme bâtie sur la confiance, le respect et l\'attention. Chez "Hussein Abdelfattah furniture", nous y parvenons en créant des produits qui répondent aux attentes et aspirations des clients qui partagent les mêmes valeurs que nous.',
        chairmanSignature: 'Sincèrement, ElHussein Abdelfattah "président"', //
        ideologyTitle: 'Notre Idéologie', //
        ideologyP1: 'Nous créons des pièces intemporelles, luxueuses, élégantes et confortables pour répondre aux demandes des marchés régionaux et mondiaux. Chaque article est produit selon les normes les plus élevées, en utilisant à la fois les dernières technologies et le savoir-faire artisanal.',
        ideologyP2: 'Nos produits sont créés pour rehausser le coin pour lequel ils sont faits ; nous créons l\'ambiance que vous rechercherez toujours et dans laquelle vous vous sentirez à l\'aise.',
        teamTitle: 'Notre Équipe', //
        teamP1: 'Nos employés sont nos atouts, notre réputation n\'est aussi bonne que les personnes qui travaillent pour nous, et c\'est pourquoi "Hussein Abdelfattah" a bâti une équipe de près de 150 employés tous dédiés à assurer la meilleure qualité dans la conception et la fabrication de meubles.',
        teamP2: 'Notre équipe vient d\'horizons et d\'expériences variés, ce qui maintient un flux de créativité inarrêtable. Notre entreprise est un employeur qui offre l\'égalité des chances. Notre direction est disponible pour développer et encourager tous les membres de l\'équipe, ainsi que pour fournir un environnement de travail durable.',
        teamP3: 'Tous les employés et la direction de "Hussein Abdelfattah furniture" opèrent avec une approche centrée sur le client.',
        showroomsTitle: 'Sièges sociaux et salles d\'exposition', //
        showroomsP1: 'Le siège social de Hussein Abdelfattah furniture est situé dans le périmètre de l\'usine à "Elsoyouf" à Alexandrie, où nous organisons des réunions, des appels et des transactions commerciales.',
        showroomsP2: 'Nous avons également deux salles d\'exposition, au Caire "Nasr City" et à Alexandrie "Smouha", où nous pouvons rencontrer nos clients et leur montrer une grande variété de nos produits.',
        productsTitle: 'Nos Produits', //
        eventsTitle: 'Communication et événements', //
        eventsP1: 'Notre entreprise est toujours soucieuse de construire des canaux de communication entre notre entreprise et nos clients du monde entier, c\'est pourquoi nous tenons toujours à participer à différentes expositions et à faire une présentation remarquable.',
        furnex2009: 'Exposition internationale Furnex 2009',
        furnex2010: 'Exposition internationale Furnex 2010',
        furnex2013: 'Exposition internationale Furnex 2013',
        houseAlex2014: 'House of furnite - Alexandrie 2014',
        furnex2016: 'Exposition internationale Furnex 2016',
        houseAlex2020: 'House of furnite - Alexandrie 2020',
        summaryTitle: 'Résumé de l\'entreprise', //
        summaryP1: 'Nous nous concentrons sur l\'amélioration continue du produit en fonction des besoins des clients et du marché. Ainsi, nous suivons spécifiquement le concept du produit.',
        summaryP2: 'Nous exportons mondialement vers différentes régions du monde telles que les États-Unis, le Canada, l\'Australie, la France, l\'Espagne, la Syrie, les Émirats et l\'Arabie Saoudite.',
        contactTitle: 'Contactez-Nous', //
        alexOfficeAddress: 'Siège social d\'Alexandrie : 38 Ahmed Riad Turk, El Soyouf, Alexandrie, Égypte',
        alexMobile1: 'Mobile : +2 01227316680',
        alexMobile2: 'Mobile (2) : +2 01005379993',
        alexLandline: 'Fixe : +2 03 5025171',
        beauBoisShowroomAddress: 'Showroom Beau bois : 34 rue Tout Ankh Amoun, Smouha, Alexandrie, Égypte',
        beauBoisMobile: 'Mobile : +201223922117',
        beauBoisLandline: 'Fixe : +2 03 4230826',
        cairoShowroomAddress: 'Showroom du Caire : Rue Al Nozha, Immeuble n° 14, Bâtiments de la société saoudienne, magasin n°3, Nasr city, Le Caire, Égypte'
      },
      catalog: { // Original content
        title: 'Nos Collections de Meubles',
        subtitle: 'Parcourez nos catégories soigneusement sélectionnées',
        livingRoom: 'Salon',
        bedroom: 'Chambre',
        diningRoom: 'Salle à Manger',
        office: 'Bureau',
        outdoor: 'Extérieur',
        products: 'Produits',
        nextPage: 'Suivant',
        prevPage: 'Précédent'
      },
      product: { // Original content
        description: 'Description',
        specifications: 'Spécifications',
        backToCatalog: 'Retour au Catalogue',
        viewDetails: 'Voir Détails',
        notFound: 'Produit non trouvé',
        backToProducts: 'Retour aux Produits',
        contactForPricing: 'Contactez pour le Prix',
        addToWishlist: 'Ajouter aux Favoris'
      },
      filter: { // Original content
        all: 'Toutes Catégories',
        allPrices: 'Tous les Prix',
        under1000: 'Moins de 1 000$',
        range1000: '1 000$ - 2 000$',
        range2000: '2 000$ - 3 000$',
        over3000: 'Plus de 3 000$',
        search: 'Rechercher produits...',
        showing: 'Affichage de',
        products: 'produits',
        noProducts: 'Aucun produit trouvé',
        tryDifferent: 'Essayez d\'ajuster vos filtres'
      },
      products: { // Original content
        subtitle: 'Découvrez notre collection complète de meubles'
      },
      contact: { // Original content for a general form
        title: 'Nous Contacter',
        subtitle: 'Nous aimerions avoir de vos nouvelles. Envoyez-nous un message et nous répondrons dès que possible.',
        interestedTitle: 'Intéressé par ce produit?',
        whatsapp: 'WhatsApp',
        call: 'Appelez-nous',
        note: 'Note',
        noteText: 'Contactez-nous pour les prix, la disponibilité et les options de livraison.',
        followUs: 'Suivez-nous',
        name: 'Votre Nom',
        email: 'Votre Email',
        message: 'Votre Message',
        send: 'Envoyer le Message',
        getInTouch: 'Nous Contacter',
        sendMessage: 'Envoyez-nous un Message',
        phone: 'Téléphone',
        address: 'Adresse',
        success: 'Succès',
        error: 'Erreur',
        successMessage: 'Votre message a été envoyé avec succès!',
        errorMessage: 'Veuillez remplir tous les champs',
        interactiveMap: 'Carte Interactive',
        visitShowroom: 'Visitez Notre Showroom',
        "swal": {
          "successTitle": "Message envoyé !",
          "successText": "Nous vous répondrons dès que possible !",
          "errorTitle": "Erreur !",
          "networkErrorText": "Une erreur est survenue lors de l'envoi du message. Veuillez réessayer."
        }
      },
      whatsapp: { // Original content
        hello: 'Bonjour! Je suis intéressé par',
        interested: 'Pourriez-vous me fournir plus d\'informations?'
      },
      "reviews": {
        "title": "Ce que disent nos clients",
        "subtitle": "Lisez les opinions et les expériences de nos précieux clients.",
        "customerReviews": "Avis des clients",
        "writeReview": "Écrivez votre avis",
        "yourName": "Votre nom",
        "rating": "Votre évaluation",
        "yourReview": "Votre avis",
        "submit": "Soumettre l'avis",
        "validation": {
          "ratingRequired": "Veuillez sélectionner votre évaluation"
        },
        "noReviewsFound": 'Aucun avis pour le moment.',
        "beTheFirst": 'Soyez le premier à partager votre opinion !',
        "swal": {
          "successTitle": "Avis soumis !",
          "successText": "Merci pour vos commentaires !",
          "errorTitle": "Erreur !",
          "networkErrorText": "Une erreur est survenue lors de la soumission. Veuillez réessayer."
        }
      },
      about: { // Original content
        title: 'À Propos d\'Élégance Meubles',
        subtitle: 'Créer de beaux espaces depuis 1995',
        description: 'Depuis plus de 25 ans, Élégance Meubles est à l\'avant-garde de la création de pièces de mobilier exceptionnelles qui transforment les maisons en foyers. Notre voyage a commencé avec une vision simple : rassembler design intemporel, artisanat supérieur et qualité sans compromis.',
        mission: 'Notre mission est de fournir à nos clients des meubles qui non seulement répondent à leurs besoins fonctionnels mais reflètent aussi leur style personnel et améliorent leurs espaces de vie. Nous croyons que les grands meubles doivent être un investissement dans le confort, la beauté et la valeur durable.',
        values: 'Nous nous engageons pour la durabilité, l\'approvisionnement éthique et le soutien aux artisans locaux. Chaque pièce de notre collection est soigneusement sélectionnée ou fabriquée avec attention aux détails, garantissant qu\'elle vous servira magnifiquement pendant des années.',
        location: 'Visitez Notre Showroom',
        address: '123 Avenue du Design, Le Caire, Égypte',
        happyCustomers: 'Clients Satisfaits',
        yearsExperience: 'Années d\'Expérience',
        customerSupport: 'Support Client',
        ourShowroom: 'Notre Showroom'
      },
      footer: {
        allRightsReserved: 'Tous droits réservés.',
        craftingSince: 'Meubles Décoratifs Depuis 1980' // Updated from PDF
      },
      "faq": {
        "title": "Questions Fréquemment Posées",
        "subtitle": "Trouvez des réponses aux questions les plus courantes sur nos produits et services.",
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;